var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FCDFDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_53296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24H28V13H12V24ZM21 26V28H25V30H15V28H19V26H10.992C10.8607 25.9992 10.7309 25.9725 10.6099 25.9215C10.4889 25.8704 10.3792 25.7959 10.287 25.7024C10.1949 25.6088 10.1221 25.498 10.0728 25.3763C10.0236 25.2546 9.99885 25.1243 10 24.993V12.007C10 11.451 10.455 11 10.992 11H29.008C29.556 11 30 11.449 30 12.007V24.993C30 25.549 29.545 26 29.008 26H21Z",
    fill: "#F15D5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_53296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorRed);
export default __webpack_public_path__ + "static/media/monitor_red.58ad3a78bfac2bf76e57f6cc0c5e2eca.svg";
export { ForwardRef as ReactComponent };